// Funciones puras para la vista de análisis del chatbot: no tocan Firebase,
// solo transforman listas de mensajes/conversaciones ya leídas. Mismo
// criterio que folioMatrixLogic.js/bulkEditLogic.js en este proyecto.

const STOPWORDS = new Set([
  "el", "la", "los", "las", "un", "una", "unos", "unas", "de", "del", "al",
  "y", "o", "que", "qué", "como", "cómo", "cuando", "cuándo", "donde", "dónde",
  "por", "para", "con", "sin", "en", "es", "son", "soy", "eres", "ser", "esta",
  "está", "estan", "están", "esto", "eso", "mi", "tu", "su", "me", "te", "se",
  "lo", "le", "les", "les", "no", "si", "sí", "más", "mas", "muy", "pero",
  "porque", "hay", "puedo", "puede", "tengo", "tiene", "quiero", "quisiera",
  "hola", "gracias", "favor", "ayuda", "ayudame", "ayúdame", "necesito", "ya",
  "una", "un", "a", "e", "ese", "esa", "esos", "esas", "yo", "tú", "él", "ella",
]);

function normalizarPalabra(palabra) {
  return palabra
    .toLowerCase()
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "") // quita acentos
    .replace(/[^a-z0-9]/g, "");
}

// Extrae las palabras más repetidas entre los mensajes de USUARIO (no de
// asistente) — heurística simple de "temas más preguntados", no
// clasificación por tópicos real. min 4 caracteres para evitar ruido.
export function temasFrecuentes(mensajesUsuario, top = 10) {
  const conteo = new Map();
  (mensajesUsuario || []).forEach((m) => {
    const palabras = (m.content || "").split(/\s+/).map(normalizarPalabra);
    const vistasEnEsteMensaje = new Set();
    palabras.forEach((p) => {
      if (p.length < 4 || STOPWORDS.has(p) || vistasEnEsteMensaje.has(p)) return;
      vistasEnEsteMensaje.add(p);
      conteo.set(p, (conteo.get(p) || 0) + 1);
    });
  });
  return Array.from(conteo.entries())
    .sort((a, b) => b[1] - a[1])
    .slice(0, top)
    .map(([palabra, veces]) => ({ palabra, veces }));
}

// Los Timestamp de Firestore no son números planos — toMillis() los
// convierte para poder ordenarlos/formatearlos igual que antes con RTDB.
// Puede venir null si el servidor todavía no confirmó el serverTimestamp()
// (lectura justo después de escribir).
export function timestampAMillis(ts) {
  if (!ts || typeof ts.toMillis !== "function") return null;
  return ts.toMillis();
}

// Recibe un QueryDocumentSnapshot de Firestore (duck-typed: {id, data()})
// y lo convierte a un objeto plano con los timestamps ya en milisegundos.
// Las consultas ya vienen ordenadas por Firestore (.orderBy(...).limit(...)),
// así que no hace falta volver a ordenar del lado del cliente.
export function mensajeDocAObjeto(doc) {
  const data = doc.data();
  return { id: doc.id, ...data, createdAt: timestampAMillis(data.createdAt) };
}

export function conversacionDocAObjeto(doc) {
  const data = doc.data();
  return {
    id: doc.id,
    ...data,
    startedAt: timestampAMillis(data.startedAt),
    lastMessageAt: timestampAMillis(data.lastMessageAt),
  };
}
